import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import AmazonSalesBanner from '../components/AmazonSalesBanner'
import CuratedPhotosHeaderForPostPurchaseModal from '../components/CuratedPhotosHeaderForPostPurchaseModal'
import DPFFaqJpSection from '../components/DPFFaqJpSection'
import Footer from '../components/Footer'
import { HeroSectionForPostPurchaseModal } from '../components/HeroSection'
import ProductPricingSection from '../components/ProductPricingSection'
import PurchaseButtons from '../components/PurchaseButtons'
import PurchaseStepsSection from '../components/PurchaseStepsSection'
import { useAppContext } from '../contexts/AppContext'
import useTracking from '../hooks/useTracking'
import { PurchaseChannelConfig } from '../types'

const DEFAULT_PURCHASE_CHANNELS: PurchaseChannelConfig[] = [
  { key: 'amazon', available: true },
  { key: 'rakuten', available: true },
]

export default function PostPurchaseModal() {
  const { t } = useTranslation('landingPage')
  const {
    isPremiumUser = false,
    userPhotos = [],
    premiumDeepLinkUrl = '',
    api,
    purchaseChannels = DEFAULT_PURCHASE_CHANNELS,
  } = useAppContext()
  const isUsingFallback = userPhotos.length === 0
  const isAmazonSaleActive = purchaseChannels.some(
    channel => channel.key === 'amazon' && channel.available && channel.saleActive,
  )

  const {
    logClickedBuyOnAmazonPostPurchaseModal,
    logClickedBuyOnRakutenPostPurchaseModal,
    logClickedLearnMoreAboutPremiumPostPurchaseModal,
    logClickedPurchaseStepsButtonAmazonPostPurchaseModal,
    logClickedPurchaseStepsButtonRakutenPostPurchaseModal,
  } = useTracking({ api: api || null })

  const handleBuyOnAmazonClick = useCallback(() => {
    logClickedBuyOnAmazonPostPurchaseModal()
  }, [logClickedBuyOnAmazonPostPurchaseModal])

  const handleBuyOnRakutenClick = useCallback(() => {
    logClickedBuyOnRakutenPostPurchaseModal()
  }, [logClickedBuyOnRakutenPostPurchaseModal])

  return (
    <>
      <div className='bg-[#FFFBED] p-4'>{t('postPurchase.thankYou')}</div>

      {isAmazonSaleActive && <AmazonSalesBanner />}

      <header className='relative'>
        <CuratedPhotosHeaderForPostPurchaseModal
          curatedPhotos={userPhotos}
          isUsingFallback={isUsingFallback}
        />
      </header>

      <HeroSectionForPostPurchaseModal />

      <ProductPricingSection
        isPremiumUser={isPremiumUser}
        premiumDeepLinkUrl={premiumDeepLinkUrl}
        purchaseChannels={purchaseChannels}
        onAmazonClick={handleBuyOnAmazonClick}
        logClickedLearnMoreAboutPremium={logClickedLearnMoreAboutPremiumPostPurchaseModal}
      />

      <PurchaseStepsSection
        logClickedPurchaseStepsButtonAmazon={logClickedPurchaseStepsButtonAmazonPostPurchaseModal}
        logClickedPurchaseStepsButtonRakuten={logClickedPurchaseStepsButtonRakutenPostPurchaseModal}
        premiumFeaturesLayout='list'
        purchaseChannels={purchaseChannels}
      />

      <DPFFaqJpSection />

      <Footer />

      <PurchaseButtons
        onAmazonClick={handleBuyOnAmazonClick}
        onRakutenClick={handleBuyOnRakutenClick}
        purchaseChannels={purchaseChannels}
      />
    </>
  )
}
